import { artConfigBuildings } from "../assetBundles/artConfigBuildings";
import { BF2GetConfigBasedBuilding } from "./BF2BuildingGraphicsUtils";
export var GetBuildingScaffoldingIso = function (data) {
    var _a = data.balancing, xExtent = _a.xExtent, yExtent = _a.yExtent;
    var config = artConfigBuildings["Scaffolding" + xExtent + "x" + yExtent];
    return BF2GetConfigBasedBuilding(data, config);
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/GetBuildingScaffoldingIso.ts
// module id = 580
// module chunks = 3